import * as ko from "knockout";
import {_} from 'lodash';
import PromiseRequest from "./PromiseRequest";
import {global} from "../appContext";
import {IEHubProcess, IEHubProcessStep, IFetchRouteDef, IRouteDefinition, IRouteParams} from "../index";
import {getServiceDefinition, TServiceDefinition, TServiceName} from "../constants/ApiServices";
import {getDisplayNameForRouteData, getSearchSystemParams} from "../util/request";
import {nsRequest} from "../req/fn";
import {isNullOrUndefinedOrEmptyString} from "../util/misc"

export class RequestRouteData {
    public req: PromiseRequest
    private readonly serviceDef: TServiceDefinition
    private readonly routeDef: IRouteDefinition
    private readonly routeParams: IRouteParams
    private readonly fetchRouteDef: IFetchRouteDef;
    private readonly serviceName: TServiceName;
    public readonly isRequesting: KnockoutObservable<boolean>;
    public readonly displayName: KnockoutObservable<string | null> = ko.observable(null);

    constructor(routeDef: IRouteDefinition, routeParams: IRouteParams) {
        this.routeDef = routeDef;
        this.routeParams = routeParams;
        if (!routeDef.fetchRouteDef) {
            throw new Error('Route definition is missing fetchRouteDef');
        }
        this.fetchRouteDef = routeDef.fetchRouteDef;
        this.serviceName = this.fetchRouteDef.serviceName;
        this.serviceDef = getServiceDefinition(this.serviceName);
        this.req = global.getPromiseRequest(this.serviceDef.name);
        this.isRequesting = this.req.isRequesting;
    }

    public request(): Promise<any[]> {
        let params = nsRequest.getParams(this.serviceName, this.routeParams, this.fetchRouteDef.params ?? {});
        switch (this.serviceName) {
            case 'searchsystem':
                params = getSearchSystemParams(params);
                break;
        }
        return this.req
            .request(params)
            .then(this.onSuccess.bind(this));
    }

    public abort() {
        this.req?.abort?.();
    }

    private onSuccess(data: any[]) {
        // there are no ids in the items produced by getehubprocess - let's generate a unique id for each instance based
        // on the steps' ids
        if (this.serviceName == 'getehubprocess') {
            data.forEach((o: IEHubProcess) => {
                o.id = o.steps.map((o: IEHubProcessStep) => o.id).join('-');
            });
        }

        this.displayName(getDisplayNameForRouteData(data, this.routeDef, this.routeParams));
        return _.cloneDeep(data);
    }
}